import React from "react";
import ReactDOM from "react-dom";
import App from "./app";

const rootElement = document.getElementById("complaint-form");
if (rootElement) {
    ReactDOM.render(<App />, rootElement);
}
